/**
 * Include your custom JavaScript here.
 */

/* Sellier: return shoppers to the product they were viewing when they press Back on a collection/search page.
   v2 (28.09.2026) - hardened for mobile: saves on tap, handles back-forward cache, re-pins position if other
   scripts jump the page, and ignores preview/page/limit params. Add ?sellier_debug=1 to the URL for an on-screen log. */
(function () {
  var KEY = 'sellierListPos';
  var MAX_AGE = 30 * 60 * 1000;
  var GRID = '.boost-pfs-filter-products';
  var IGNORE = ['page', 'limit', 'preview_theme_id', '_pos', '_sid', '_ss', 'sellier_debug'];
  var DEBUG = /sellier_debug=1/.test(location.search) || (function () { try { return sessionStorage.getItem('sellierDebug') === '1'; } catch (e) { return false; } })();
  if (/sellier_debug=1/.test(location.search)) { try { sessionStorage.setItem('sellierDebug', '1'); } catch (e) {} }

  var box = null;
  function log(msg) {
    if (!DEBUG) return;
    if (!box) {
      box = document.createElement('div');
      box.style.cssText = 'position:fixed;left:0;right:0;bottom:0;max-height:35vh;overflow:auto;z-index:2147483647;background:rgba(0,0,0,.85);color:#0f0;font:11px/1.4 monospace;padding:6px;white-space:pre-wrap';
      (document.body || document.documentElement).appendChild(box);
    }
    box.textContent += new Date().toISOString().substr(17, 6) + ' ' + msg + '\n';
  }

  function listKey() {
    var params = new URLSearchParams(location.search);
    IGNORE.forEach(function (p) { params.delete(p); });
    params.sort && params.sort();
    var q = params.toString();
    return location.pathname.replace(/\/$/, '') + (q ? '?' + q : '');
  }

  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function remember(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!a || !a.closest(GRID)) return;
    var handle = handleFromHref(a.getAttribute('href'));
    if (!handle) return;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ list: listKey(), handle: handle, y: window.pageYOffset, t: Date.now() }));
      log('saved ' + handle + ' y=' + window.pageYOffset + ' on ' + e.type);
    } catch (err) { log('save failed: ' + err); }
  }
  // Save on tap as well as click - some mobile setups navigate before "click" reaches us
  ['touchstart', 'mousedown', 'click'].forEach(function (ev) {
    document.addEventListener(ev, remember, { capture: true, passive: true });
  });

  function restore(reason) {
    var saved;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (err) { saved = null; }
    log('restore(' + reason + ') list=' + listKey() + ' saved=' + (saved ? saved.list + ' ' + saved.handle : 'none'));
    if (!saved || saved.list !== listKey() || Date.now() - saved.t > MAX_AGE) return;

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    var clicks = 0, done = false, timer = null, observer = null, userMoved = false;
    var started = Date.now();

    function stopOnUser() { userMoved = true; }
    ['touchmove', 'wheel', 'keydown'].forEach(function (ev) { window.addEventListener(ev, stopOnUser, { passive: true, once: true }); });

    function findItem() {
      var links = document.querySelectorAll(GRID + ' a[href*="/products/"]');
      for (var i = 0; i < links.length; i++) {
        if (handleFromHref(links[i].getAttribute('href')) === saved.handle) {
          return links[i].closest('.product-grid-item-alt') || links[i];
        }
      }
      return null;
    }

    function findLoadMore() {
      var els = document.querySelectorAll('.boost-pfs-filter-load-more-button, .boost-pfs-filter-load-more button, .boost-pfs-filter-load-more a');
      for (var i = 0; i < els.length; i++) {
        if (els[i].offsetParent !== null && !els[i].disabled) return els[i];
      }
      return null;
    }

    function pin(item) {
      // Other scripts (filter app, lazy images, theme) can jump the page after we scroll.
      // Keep the item centred for ~3s unless the shopper starts scrolling themselves.
      var until = Date.now() + 3000;
      (function hold() {
        if (userMoved || Date.now() > until) { log('pin released' + (userMoved ? ' (user scrolled)' : '')); return; }
        var r = item.getBoundingClientRect();
        var target = r.top + r.height / 2 - window.innerHeight / 2;
        if (Math.abs(target) > 40) { window.scrollBy(0, target); log('re-pinned by ' + Math.round(target) + 'px'); }
        setTimeout(hold, 150);
      })();
    }

    function finish(msg) {
      done = true;
      if (observer) observer.disconnect();
      try { sessionStorage.removeItem(KEY); } catch (err) {}
      log('finished: ' + msg);
    }

    function attempt() {
      if (done) return;
      if (userMoved) return finish('user scrolled first');
      if (Date.now() - started > 20000) {
        if (saved.y) window.scrollTo(0, saved.y);
        return finish('timeout, fell back to y=' + saved.y);
      }
      var item = findItem();
      if (item) {
        item.scrollIntoView({ block: 'center' });
        pin(item);
        return finish('found ' + saved.handle + ' after ' + clicks + ' load-more clicks');
      }
      var more = findLoadMore();
      if (more && clicks < 25) { clicks++; log('clicking load more #' + clicks); more.click(); }
    }

    observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(attempt, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    attempt();
  }

  function navType() {
    try { var n = performance.getEntriesByType('navigation')[0]; if (n) return n.type; } catch (e) {}
    return 'unknown';
  }

  function init() {
    log('page load, nav=' + navType() + ', width=' + window.innerWidth);
    restore('load');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Mobile browsers often restore the page from memory (back-forward cache) without re-running scripts
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      log('pageshow from back-forward cache, y=' + window.pageYOffset);
      restore('bfcache');
    }
  });
})();
